import axios from "axios";

const TOKEN_KEY = "bhd_admin_token";
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

let onUnauthorized = () => {};
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

export const adminApi = axios.create({ baseURL: process.env.REACT_APP_API_BASE });

adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

adminApi.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 401 && !err.config?.url?.includes("/admin/login")) {
    clearToken();
    onUnauthorized();
  }
  return Promise.reject(err);
});

export const detail = (e, fallback = "Došlo je do greške.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

const pad = (n) => String(n).padStart(2, "0");
export const fmtDate = (ts) => {
  if (!ts) return "—";
  const d = new Date(ts * 1000);
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const fmtDay = (ts) => { const d = new Date(ts * 1000); return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.`; };
export const eur = (n) => `${Number(n || 0).toFixed(2)}€`;

export const STATUS = {
  active: { label: "Aktivan", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  trial: { label: "Proba", cls: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30" },
  expired: { label: "Istekao", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  blocked: { label: "Blokiran", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
};
export const PLAN = { yearly: "Godišnji", lifetime: "Doživotni", trial: "Proba" };
export const METHOD = { stripe: "Stripe", admin: "Ručno (admin)" };

export const expiresText = (d) => {
  if (d.status === "active" && !d.expires_at) return "Doživotno";
  if (d.status === "trial") return `za ${d.days_left ?? 0} dana (proba)`;
  if (d.status === "active") return `za ${d.days_left ?? 0} dana`;
  return "Isteklo";
};
